import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Type from '../Typography';

import styles from './PageIndex.less';

export default React.memo(PageIndex);

const cx = classnames.bind(styles);

const Svg = React.memo((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="16" height="16" {...props} />
));

//<i className="icon-double-arrow-left"/>
const DoubleArrowLeft = React.memo(() => (
  <Svg>
    <path d="M1020.36 889.68c-1.08 3.79-2 7.64-3.27 11.36-9.63 27.87-41.59 46.17-72.37 41.88a77.14 77.14 0 0 1-42-19.7c-136-122-272.04-243.94-408.13-365.83-29.13-26.09-29.15-62.76-.09-88.79a553854.3 553854.3 0 0 0 406.34-364.23c12.21-11 25.56-18.84 42-21 .76-.21 1.5-.51 2.18-.91h16.76c1.68.46 3.34 1 5 1.37 23.84 5.17 41.58 17.79 50.44 41.24 1.23 3.28 2.14 6.69 3.14 10.03v14.35c-3.36 17.92-13.92 30.88-27.25 42.79a163872.15 163872.15 0 0 0-354 317c-1.29 1.16-3.07 1.79-4.9 2.83 2.93 2.75 4.34 4.13 5.8 5.44 116.47 104.39 232.98 208.72 349.53 313 14.4 12.87 27.45 26 30.85 46l-.03 13.17z" />
    <path d="M493.02 82.49c4.77 1.25 9.61 2.3 14.3 3.8 27 8.59 44.83 32 44.08 58.06-.48 16.86-7.91 30.55-20.37 41.7-32.67 29.24-65.32 58.5-97.95 87.77L169.97 509.6c-1 .92-2.08 1.83-4.84 4.25 2.17 1.24 4.13 1.95 5.57 3.24 118.9 106.48 237.79 212.97 356.66 319.47 11 9.81 20.05 20.63 22.83 35.44 4.41 23.49-3.89 42.4-22.32 56.8-27 21.13-66.13 19.14-92.36-4.29a42935.77 42935.77 0 0 1-92.15-82.58c-105.8-94.82-211.61-189.64-317.42-284.46-29.37-26.31-29.27-62.81.19-89.2 135.37-121.25 270.71-242.55 406-363.9 12.2-11 25.56-18.84 42-21 .76-.21 1.5-.51 2.18-.91l16.71.03z" />
  </Svg>
));

//<i className="icon-double-arrow-right"/>
const DoubleArrowRight = React.memo(() => (
  <Svg>
    <path d="M4 136.32c1.08-3.79 2-7.64 3.27-11.36 9.63-27.87 41.59-46.17 72.37-41.88a77.14 77.14 0 0 1 42 19.7c136 122 272.04 243.94 408.13 365.83 29.13 26.09 29.15 62.76.09 88.79a553854.3 553854.3 0 0 0-406.34 364.23c-12.21 11-25.56 18.84-42 21-.76.21-1.5.51-2.18.91H62.58c-1.68-.46-3.34-1-5-1.37C33.74 937 16 924.38 7.14 900.93 5.91 897.65 5 894.24 4 890.9v-14.35c3.36-17.92 13.92-30.88 27.25-42.79a163872.15 163872.15 0 0 0 354-317c1.29-1.16 3.07-1.79 4.9-2.83-2.93-2.75-4.34-4.13-5.8-5.44a542293.207 542293.207 0 0 0-349.53-313c-14.4-12.87-27.45-26-30.85-46L4 136.32z" />
    <path d="M531.34 943.51c-4.77-1.25-9.61-2.3-14.3-3.8-27-8.59-44.83-32-44.08-58.06.48-16.86 7.91-30.55 20.37-41.7 32.67-29.24 65.32-58.5 97.95-87.77L854.39 516.4c1-.92 2.08-1.83 4.84-4.25-2.17-1.24-4.13-1.95-5.57-3.24C734.76 402.43 615.87 295.94 497 189.44c-11-9.81-20.05-20.63-22.83-35.44-4.41-23.49 3.89-42.4 22.32-56.8 27-21.13 66.13-19.14 92.36 4.29 30.77 27.49 61.48 55.02 92.15 82.58 105.8 94.82 211.61 189.64 317.42 284.46 29.37 26.31 29.27 62.81-.19 89.2a774950.914 774950.914 0 0 0-406 363.9c-12.2 11-25.56 18.84-42 21-.76.21-1.5.51-2.18.91l-16.71-.03z" />
  </Svg>
));

//<i className="icon-chevron-left"/>
const ArrowLeft = React.memo(() => (
  <Svg>
    <path
      d="M721.26 70.58c4.77 1.25 9.61 2.3 14.3 3.8 27 8.59 44.83 32 44.08 58.06-.48 16.86-7.91 30.55-20.37 41.7-32.67 29.24-65.32 58.5-97.95 87.77L398.21 497.69c-1 .92-2.08 1.83-4.84 4.25 2.17 1.24 4.13 1.95 5.57 3.24 118.9 106.48 237.79 212.97 356.66 319.47 11 9.81 20.05 20.63 22.83 35.44 4.41 23.49-3.89 42.4-22.32 56.8-27 21.13-66.13 19.14-92.36-4.29a42935.77 42935.77 0 0 1-92.15-82.58C465.8 735.2 359.99 640.38 254.18 545.56c-29.37-26.31-29.27-62.81.19-89.2 135.37-121.25 270.71-242.55 406-363.9 12.2-11 25.56-18.84 42-21 .76-.21 1.5-.51 2.18-.91l16.71.03z"
      id="LEFT"
    />
  </Svg>
));

//<i className="icon-chevron-right"/>
const ArrowRight = React.memo(() => (
  <Svg>
    <path
      d="M294.62 945.51c-4.77-1.25-9.61-2.3-14.3-3.8-27-8.59-44.83-32-44.08-58.06.48-16.86 7.91-30.55 20.37-41.7 32.67-29.24 65.32-58.5 97.95-87.77L617.67 518.4c1-.92 2.08-1.83 4.84-4.25-2.17-1.24-4.13-1.95-5.57-3.24-118.9-106.48-237.79-212.97-356.66-319.47-11-9.81-20.05-20.63-22.83-35.44-4.41-23.49 3.89-42.4 22.32-56.8 27-21.13 66.13-19.14 92.36 4.29 30.77 27.49 61.48 55.02 92.15 82.58 105.8 94.82 211.61 189.64 317.42 284.46 29.37 26.31 29.27 62.81-.19 89.2a774950.914 774950.914 0 0 0-406 363.9c-12.2 11-25.56 18.84-42 21-.76.21-1.5.51-2.18.91l-16.71-.03z"
      id="RIGHT_copy"
    />
  </Svg>
));

const REMAP = {
  '<<': React.createElement(DoubleArrowLeft),
  '<': React.createElement(ArrowLeft),
  '>>': React.createElement(DoubleArrowRight),
  '>': React.createElement(ArrowRight),
};

PageIndex.propTypes = {
  /** Show as active */
  active: PropTypes.bool,
  /** Route/Link target */
  href: PropTypes.string,
  /** Callback to call on click */
  onClick: PropTypes.func,
  /** Custom classnames for various states */
  classes: PropTypes.shape({
    active: PropTypes.string,
  }),
};

/** @private */
function PageIndex({ active, classes, className, children, disabled, label, href, ...props }) {
  const { active: activeClass } = classes || {};

  const customClass = activeClass ? { [activeClass]: active } : {};

  const content = REMAP[label] || label || children;
  const isLink = !disabled && href !== '';

  return (
    <Type
      as={!isLink || href === '#' ? 'button' : 'a'}
      className={cx('root', className, {
        active,
        ...customClass,
      })}
      disabled={disabled}
      href={href}
      {...props}
    >
      {content}
    </Type>
  );
}
